import React, { useMemo } from "react";
import Cleave from "cleave.js/react";

import { getLocaleMoneySeparators } from "../../helpers/money";

interface MoneyInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  locale: string;
  placeholder?: string;
  invalid?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}

const MoneyInput = ({
  id,
  value,
  onChange,
  onBlur,
  onKeyDown,
  locale,
  placeholder,
  invalid = false,
  disabled = false,
  autoFocus = false,
}: MoneyInputProps) => {
  const { decimal, group } = useMemo(
    () => getLocaleMoneySeparators(locale),
    [locale]
  );

  return (
    <Cleave
      id={id}
      className={`form-control${invalid ? " is-invalid" : ""}`}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      options={{
        numeral: true,
        numeralDecimalMark: decimal,
        delimiter: group,
        numeralDecimalScale: 2,
        numeralPositiveOnly: true,
      }}
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        onChange(event.target.value)
      }
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
};

export default MoneyInput;
